/**
 * Fetches Transaction Recovered from Crash or WIN Death
 *
 * @param {*} state
 * @returns {Object} Card Reader Data
 */
export const getRecoveryData = (state) => {
  return state.VNTransactions?.recovered
}

/**
 * Indicate if we have any card recovery data
 *
 * @param {*} state
 * @returns {Boolean}
 */
export const getHasRecoveryData = (state) => {
  const recoveredData = state.VNTransactions?.recovered ?? {}
  return !!Object.keys(recoveredData).length
}

/**
 * Last Transaction orderUUID
 *
 * @param {*} state
 * @returns {String}
 */
export const getOrderUUID = (state) => {
  return state.VNTransactions?.order?.uuid
}

/**
 * Transaction Order (Invoice) Number
 *
 * @param {*} state
 * @returns {String}
 */
export const getOrderNumber = (state) => {
  return state.VNTransactions?.order?.orderNumber
}

/**
 * Transaction paymentId generated from tenders
 *
 * @param {*} state
 * @returns {String}
 */
export const getPaymentId = (state) => {
  return state.VNTransactions?.order?.paymentId
}

/**
 * Transaction AttendantId
 *
 * @param {*} state
 * @returns {String}
 */
export const getAttendantId = (state) => {
  return state.VNTransactions?.order?.attendantId
}

/**
 * Flag to indicate if a tip has been applied to the transaction
 *
 * @param {*} state
 * @returns {Boolean}
 */
export const getHasTipApplied = (state) => {
  return state.VNTransactions?.order?.hasTipApplied ?? false
}

/**
 * Last Tranaction's "signature" when available
 *
 * @param {*} state
 * @returns {?String}
 */
export const getSignature = (state) => {
  return state.VNTransactions?.order?.signature ?? null
}

/**
 * Order Amount in Cents
 *
 * @param {*} state
 * @returns {?Number}
 */
export const getBalanceDueInCents = (state) => {
  return state.VNTransactions?.order?.balanceDueInCents ?? null
}

/**
 * Order Payments
 *
 * @param {*} state
 * @returns {Array}
 */
export const getPayments = (state) => {
  return state.VNTransactions?.order?.payments ?? []
}

/**
 * Selected Tip Amount in Cents (if available)
 *
 * @param {Object} state
 * @returns {?Number}
 */
export const getTipAmountCents = (state) => {
  return state.VNTransactions?.order?.tipAmountInCents ?? null
}

/**
 * Selected Tender Amount in Cents
 *
 * @param {Object} state
 * @returns {?Number}
 */
export const getTenderAmountInCents = (state) => {
  return state.VNTransactions?.order?.tenderAmountInCents ?? null
}

/**
 * Flag to indicate if transaction is for a card authorization
 *
 * @param {Object} state
 * @returns {Boolean}
 */
export const getIsAuthorization = (state) => {
  return state.VNTransactions?.order?.isAuthorization ?? false
}

/**
 * Cart Line Items for the Purposes of resuming tab transactions
 *
 * @param {Object} state
 * @returns {Array}
 */
export const getLineItems = (state) => {
  return state.VNTransactions?.order?.lineItems ?? []
}
